import React, { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';

const WelcomeCelebration = () => {
    const [showCelebration, setShowCelebration] = useState(false);

    useEffect(() => {
        const checkCelebration = () => {
            const lastCelebration = localStorage.getItem('lastCelebrationDate');
            const today = new Date().toDateString();

            if (lastCelebration !== today) {
                // Determine greeting based on time
                const hour = new Date().getHours();
                let greeting = 'Good Morning';
                if (hour >= 12 && hour < 17) greeting = 'Good Afternoon';
                else if (hour >= 17) greeting = 'Good Evening';

                // Trigger confetti
                setShowCelebration({ greeting, name: 'JP' });
                triggerConfetti();

                // Save today's date
                localStorage.setItem('lastCelebrationDate', today);

                // Auto hide after 3.5 seconds
                setTimeout(() => {
                    setShowCelebration(false);
                }, 3500);
            }
        };

        checkCelebration();
    }, []);

    const triggerConfetti = () => {
        const duration = 2000;
        const animationEnd = Date.now() + duration;
        const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

        const random = (min, max) => Math.random() * (max - min) + min;

        const interval = setInterval(function () {
            const timeLeft = animationEnd - Date.now();

            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / duration);

            // Gold and White Confetti
            confetti({
                ...defaults,
                particleCount,
                origin: { x: random(0.1, 0.3), y: Math.random() - 0.2 },
                colors: ['#B8860B', '#FFFFFF', '#ffd700']
            });
            confetti({
                ...defaults,
                particleCount,
                origin: { x: random(0.7, 0.9), y: Math.random() - 0.2 },
                colors: ['#B8860B', '#FFFFFF', '#ffd700']
            });
        }, 250);
    };

    if (!showCelebration) return null;

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 10000,
            background: 'rgba(255, 255, 255, 0.95)',
            padding: '12px 24px',
            borderRadius: '50px',
            boxShadow: '0 8px 32px rgba(184, 134, 11, 0.2)',
            border: '1px solid var(--gold-border)',
            textAlign: 'center',
            animation: 'slideDown 0.5s ease-out'
        }}>
            <div style={{ fontSize: '20px' }}>🎉</div>
            <div style={{ fontWeight: 'bold', color: 'var(--gold-primary)', fontSize: '14px' }}>
                Welcome Back, {showCelebration.name}!
            </div>
            <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                Wishing you a profitable day! ✨
            </div>
            <style>{`
                @keyframes slideDown {
                    from { transform: translate(-50%, -100px); opacity: 0; }
                    to { transform: translate(-50%, 0); opacity: 1; }
                }
            `}</style>
        </div>
    );
};

export default WelcomeCelebration;
